import jwtDecode from "jwt-decode"
import { removeLocalStorage, getLocalStorage } from "./tokenstorage"

interface Token {
  exp: number
  role: string
  roles?: string[] // new: multiple roles
  username: string
  id: number
  hub_id: number
  hub_ids?: number[] // new: multiple hubs
  hub_name: string
}

export const Auth = {
  isLogged() {
    const storedToken = getLocalStorage() && getLocalStorage().token
    if (storedToken) {
      const token: Token = jwtDecode(storedToken)
      if (typeof token === "object" && token !== null) {
        if (token.exp < Date.now() / 1000) {
          removeLocalStorage()
          return false
        }
      }
      return true
    }
    return false
  },
  role() {
    const storedToken = getLocalStorage() && getLocalStorage().token
    if (storedToken) {
      const token: Token = jwtDecode(storedToken)
      return String(token.role)
    }
    return null
  },
  roles(): string[] {
    const storedToken = getLocalStorage() && getLocalStorage().token
    if (storedToken) {
      const token: Token = jwtDecode(storedToken)
      // Return roles array if available, otherwise fallback to single role
      if (token.roles && token.roles.length > 0) {
        return token.roles
      }
      return token.role ? [token.role] : []
    }
    return []
  },
  hasRole(role: string): boolean {
    return this.roles().includes(role)
  },
  // True only when rider is the user's highest role (no admin or hub_admin present).
  // Use this to gate rider-specific behavior — NOT for feature access checks.
  isOnlyRider(): boolean {
    return (
      this.hasRole("rider") &&
      !this.hasRole("admin") &&
      !this.hasRole("hub_admin")
    )
  },
  hasAnyRole(roles: string[]): boolean {
    const userRoles = this.roles()
    return roles.some(role => userRoles.includes(role))
  },
  username() {
    const storedToken = getLocalStorage() && getLocalStorage().token
    if (storedToken) {
      const token: Token = jwtDecode(storedToken)
      return token.username
    }
    return null
  },
  userid() {
    const storedToken = getLocalStorage() && getLocalStorage().token
    if (storedToken) {
      const token: Token = jwtDecode(storedToken)
      return token.id
    }
    return null
  },
  hubid() {
    const storedToken = getLocalStorage() && getLocalStorage().token
    if (storedToken) {
      const token: Token = jwtDecode(storedToken)
      return token.hub_id
    }
    return null
  },
  hubname() {
    const storedToken = getLocalStorage() && getLocalStorage().token
    if (storedToken) {
      const token: Token = jwtDecode(storedToken)
      return token.hub_name
    }
    return null
  },
  hubids(): number[] | null {
    const storedToken = getLocalStorage() && getLocalStorage().token
    if (storedToken) {
      const token: Token = jwtDecode(storedToken)
      if (token.hub_ids && token.hub_ids.length > 0) return token.hub_ids
      if (token.hub_id) return [token.hub_id]
    }
    return null
  },
}
